<template>
  <div id="signup">
    <div class="d-flex flex-column">
      <div class="pl-4 pr-4">
        <h4 class="font-weight-bolder">Inscription</h4>
        <b-form @submit="onSignUp">
          <b-form-input
            v-model="email"
            type="text"
            class="mb-3 border"
            :class="{'border-danger': inputError}"
            id="email-signup"
            placeholder="Email"
          ></b-form-input>
          <b-form-input
            class="mb-3 border"
            :class="{'border-danger': inputError}"
            id="password-signup"
            v-model="password"
            type="password"
            placeholder="Mot de passe"
          ></b-form-input>
          <p class="text-danger" v-if="inputError">
            Votre email ou mot de passe est incorrect !
          </p>
          <div class="mx-auto row mb-2">
            <b-button class="col button-cta-primary" @click="onSignUp" variant="success">
              Confirmer
            </b-button>
          </div>
        </b-form>
        <div class="text-small text-center">
          Vous avez déjà un compte ? <br>
          <router-link class="login-account font-weight-light" to="/login">
            Connectez vous !
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'signup',
  data () {
    return {
      email: '',
      password: '',
      inputError: false
    }
  },
  methods: {
    onSignUp: function () {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.$router.replace('home')
        },
        (err) => {
          this.inputError = true
          console.log(err)
        }
      )
    }
  }
}
</script>
<style>
  .login-account {
    color: #3AAFB4;
    font-weight: 500;
    text-decoration: underline;
  }
  .button-primary {
    background-color: #3AAFB4 !important;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/SignupComponent.vue